<script setup lang="ts">
import { ref } from 'vue';
import StarryBackground from './StarryBackground.vue';

const isNorthernLights = ref(true);

const toggleNorthernLights = () => {
  isNorthernLights.value = !isNorthernLights.value;
};
</script>

<template>
  <div class="fixed inset-0 z-[-1]">
    <NorthernLights v-if="isNorthernLights" class="w-full h-full northern-lights-overlay"/>
    <StarryBackground />
  </div>
  <button @click="toggleNorthernLights" class="z-50 fixed bottom-4 right-4 bg-white bg-opacity-20 text-white px-4 py-2 rounded-full hover:bg-opacity-30 transition-colors duration-200">
    {{ isNorthernLights ? 'Disable' : 'Enable' }} Northern Lights
  </button>
</template>

<style scoped>
.northern-lights-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
}
</style>
